/**
 * Studio Letters — shared form submit + delayed modal / mobile sheet.
 * Config from #studio-letters-config JSON.
 */
(function () {
  'use strict';

  var STORAGE_DISMISS = 'tcn_studio_letters_dismissed_at';
  var STORAGE_SUBSCRIBED = 'tcn_studio_letters_subscribed';
  var STORAGE_PAGEVIEWS = 'tcn_studio_letters_pageviews';
  var ROOT_PROMPT = '[data-studio-letters-prompt]';
  var FORM_ROOT = '[data-studio-letters-form]';
  var OPEN_SEL = '[data-studio-letters-open]';
  var TEASER_SEL = '[data-studio-letters-teaser]';

  var config = {};
  var promptEl = null;
  var dialogEl = null;
  var teaserEl = null;
  var lastFocus = null;
  var autoEligible = false;
  var autoShown = false;
  var scrollDepth = 0;
  var startedAt = Date.now();
  var focusTrapHandler = null;

  function readConfig() {
    var node = document.getElementById('studio-letters-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function isCartOrCheckout() {
    var path = (window.location && window.location.pathname) || '';
    if (/\/cart(\/|$)/i.test(path) || /\/checkouts?\//i.test(path)) return true;
    var body = document.body;
    if (!body) return false;
    return (
      body.classList.contains('template-cart') ||
      body.classList.contains('template-checkout') ||
      (typeof body.className === 'string' && body.className.indexOf('checkout') !== -1)
    );
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function isSubscribed() {
    return storageGet(STORAGE_SUBSCRIBED) === '1';
  }

  function markSubscribed() {
    storageSet(STORAGE_SUBSCRIBED, '1');
  }

  function cooldownMs() {
    var days = parseInt(config.cooldown_days, 10);
    if (isNaN(days) || days < 7) days = 10;
    if (days > 14) days = 14;
    return days * 24 * 60 * 60 * 1000;
  }

  function isInCooldown() {
    var raw = storageGet(STORAGE_DISMISS);
    if (!raw) return false;
    var ts = parseInt(raw, 10);
    if (isNaN(ts)) return false;
    return Date.now() - ts < cooldownMs();
  }

  function markDismissed() {
    storageSet(STORAGE_DISMISS, String(Date.now()));
  }

  function bumpPageViews() {
    if (isDesignMode()) return 1;
    var n = parseInt(storageGet(STORAGE_PAGEVIEWS) || '0', 10);
    if (isNaN(n)) n = 0;
    n += 1;
    storageSet(STORAGE_PAGEVIEWS, String(n));
    return n;
  }

  function cookieBannerOpen() {
    if (window.tcnCookieConsent && typeof window.tcnCookieConsent.hasDecision === 'function') {
      if (window.tcnCookieConsent.hasDecision()) return false;
    }
    if (document.documentElement.classList.contains('tcn-cookie-accepted')) return false;
    var banner = document.querySelector('.jscookie_popup');
    if (!banner) return false;
    if (banner.hasAttribute('hidden')) return false;
    if (banner.classList.contains('d-none')) return false;
    var style = window.getComputedStyle(banner);
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
    return true;
  }

  function otherModalOpen() {
    if (document.querySelector('.header2-mega-panel:not([hidden])')) return true;
    if (document.querySelector('.header2-mobile-overlay.is-open, .header2-mobile-overlay[aria-hidden="false"]')) return true;
    if (document.body && document.body.classList.contains('tcn-stay-in-touch-open')) return true;
    if (document.querySelector('.jsengo_popup:not(.d-none)')) return true;
    return false;
  }

  function track(eventName, placement) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        studio_letters_placement: placement || 'unknown'
      });
    } catch (e) {}
  }

  function setStatus(root, type, message) {
    var status = root.querySelector('[data-studio-letters-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.remove('is-success', 'is-error');
    if (type) status.classList.add(type);
  }

  function bindForm(root) {
    if (!root || root.__slBound) return;
    var form = root.querySelector('form.studio-letters-form__form') || root.querySelector('[data-studio-letters-form-el]');
    if (!form) return;
    root.__slBound = true;
    var placement = root.getAttribute('data-studio-letters-placement') || 'footer';
    var submitBtn = form.querySelector('[data-studio-letters-submit]');
    var successTpl = form.querySelector('[data-studio-letters-success-template]');
    var successMsg =
      (successTpl && successTpl.textContent && successTpl.textContent.trim()) ||
      'You’re on the studio list. Thank you for joining.';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.__slSubmitting) return;

      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value || !email.checkValidity()) {
        setStatus(root, 'is-error', 'Please enter a valid email address.');
        if (email) email.focus();
        track('studio_letters_error', placement);
        return;
      }

      form.__slSubmitting = true;
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        var label = submitBtn.querySelector('.studio-letters-form__submit-label');
        var loading = submitBtn.querySelector('.studio-letters-form__submit-loading');
        if (label) label.hidden = true;
        if (loading) loading.hidden = false;
      }
      setStatus(root, null, '');
      track('studio_letters_submit', placement);

      var action = form.getAttribute('action') || '/contact';
      var body = new FormData(form);

      fetch(action, {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) {
          if (res.status >= 500) throw new Error('server');
          markSubscribed();
          root.classList.add('is-success');
          setStatus(root, 'is-success', successMsg);
          track('studio_letters_success', placement);
          if (promptEl && promptEl.classList.contains('is-open')) {
            window.setTimeout(function () {
              closePrompt(true);
            }, 1600);
          }
        })
        .catch(function () {
          setStatus(root, 'is-error', 'Something went wrong. Please try again.');
          track('studio_letters_error', placement);
        })
        .finally(function () {
          form.__slSubmitting = false;
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            var label2 = submitBtn.querySelector('.studio-letters-form__submit-label');
            var loading2 = submitBtn.querySelector('.studio-letters-form__submit-loading');
            if (label2) label2.hidden = false;
            if (loading2) loading2.hidden = true;
          }
        });
    });
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function closeHeaderOverlays() {
    try {
      document.querySelectorAll('.header2-mega-panel:not([hidden])').forEach(function (panel) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      });
      var backdrop = document.querySelector('[data-header2-mega-backdrop]');
      if (backdrop) {
        backdrop.hidden = true;
        backdrop.setAttribute('aria-hidden', 'true');
      }
      var overlay = document.querySelector('.header2-mobile-overlay');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
      }
      document.documentElement.classList.remove('header2-mega-open', 'header2-mobile-open');
      document.body.classList.remove('header2-mega-open', 'header2-mobile-open');
      document.querySelectorAll('[data-header2-panel-trigger][aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    } catch (e) {}
  }

  function ensurePromptEls() {
    if (!promptEl || !document.body.contains(promptEl)) {
      promptEl = document.querySelector(ROOT_PROMPT);
    }
    if (promptEl) {
      dialogEl = promptEl.querySelector('[data-studio-letters-dialog]');
    }
    if (!teaserEl || !document.body.contains(teaserEl)) {
      teaserEl = document.querySelector(TEASER_SEL);
    }
    return !!(promptEl && dialogEl);
  }

  function openPrompt(source) {
    if (!ensurePromptEls()) return;

    /* Nav / teaser always open; auto still respects subscriber suppression */
    if (isSubscribed() && source !== 'navigation' && source !== 'teaser') return;
    if (cookieBannerOpen() && source !== 'navigation' && source !== 'teaser') return;

    if (source === 'navigation' || source === 'teaser') {
      closeHeaderOverlays();
    }

    lastFocus = document.activeElement;
    promptEl.hidden = false;
    promptEl.classList.add('is-open');
    promptEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('studio-letters-prompt-open');
    if (teaserEl) teaserEl.classList.remove('is-visible');

    window.requestAnimationFrame(function () {
      var focusables = getFocusable(dialogEl);
      var email = dialogEl.querySelector('input[type="email"]');
      (email || focusables[0] || dialogEl).focus();
    });

    focusTrapHandler = function (e) {
      if (e.key !== 'Tab' || !dialogEl) return;
      var nodes = getFocusable(dialogEl);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', focusTrapHandler);

    track('studio_letters_open', source || 'modal');
  }

  function closePrompt(fromSuccess) {
    if (!promptEl) return;
    promptEl.classList.remove('is-open');
    promptEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('studio-letters-prompt-open');
    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
      focusTrapHandler = null;
    }
    window.setTimeout(function () {
      if (!promptEl.classList.contains('is-open')) promptEl.hidden = true;
    }, prefersReducedMotion() ? 0 : 320);

    if (!fromSuccess && !isDesignMode()) {
      markDismissed();
      track('studio_letters_dismiss', 'modal');
      if (config.show_teaser !== false && teaserEl && !isSubscribed()) {
        teaserEl.classList.add('is-visible');
      }
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  function updateScrollDepth() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = window.pageYOffset || doc.scrollTop || 0;
    var height = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0) - window.innerHeight;
    if (height <= 0) {
      scrollDepth = 100;
      return;
    }
    scrollDepth = Math.max(scrollDepth, Math.round((scrollTop / height) * 100));
  }

  function engagementMet() {
    var pageviews = parseInt(storageGet(STORAGE_PAGEVIEWS) || '1', 10);
    var elapsed = (Date.now() - startedAt) / 1000;
    var delay = parseInt(config.delay_seconds, 10);
    var scrollNeed = parseInt(config.scroll_percent, 10);

    if (isMobile()) {
      if (isNaN(delay) || delay < 1) delay = 30;
      if (isNaN(scrollNeed) || scrollNeed < 1) scrollNeed = 60;
      if (pageviews >= 2) return true;
      return elapsed >= delay && scrollDepth >= scrollNeed;
    }

    if (isNaN(delay) || delay < 1) delay = 25;
    if (isNaN(scrollNeed) || scrollNeed < 1) scrollNeed = 55;
    if (pageviews >= 2) return true;
    return elapsed >= delay && scrollDepth >= scrollNeed;
  }

  function maybeAutoOpen() {
    if (autoShown || !config.auto_prompt) return;
    if (isDesignMode()) return;
    if (isCartOrCheckout()) return;
    if (isSubscribed() || isInCooldown()) return;
    if (cookieBannerOpen() || otherModalOpen()) return;
    if (!engagementMet()) return;
    autoShown = true;
    openPrompt('auto');
    track('studio_letters_impression', 'modal');
  }

  function onExitIntent(e) {
    if (!config.auto_prompt || isMobile() || autoShown) return;
    if (e.clientY > 12) return;
    maybeAutoOpen();
  }

  function bindOpenTriggers() {
    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target && e.target.closest ? e.target.closest(OPEN_SEL) : null;
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        openPrompt(trigger.getAttribute('data-studio-letters-source') || 'navigation');
      },
      true
    );
  }

  function init() {
    if (window.__studioLettersInit) {
      document.querySelectorAll(FORM_ROOT).forEach(bindForm);
      return;
    }
    window.__studioLettersInit = true;

    config = readConfig();
    promptEl = document.querySelector(ROOT_PROMPT);
    dialogEl = promptEl ? promptEl.querySelector('[data-studio-letters-dialog]') : null;
    teaserEl = document.querySelector(TEASER_SEL);

    document.querySelectorAll(FORM_ROOT).forEach(bindForm);
    bumpPageViews();
    bindOpenTriggers();

    if (promptEl) {
      promptEl.addEventListener('click', function (e) {
        if (e.target === promptEl) closePrompt(false);
      });
      var closeBtn = promptEl.querySelector('[data-studio-letters-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closePrompt(false);
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && promptEl.classList.contains('is-open')) {
          closePrompt(false);
        }
      });
    }

    if (teaserEl) {
      teaserEl.addEventListener('click', function () {
        openPrompt('teaser');
      });
    }

    if (config.auto_prompt && !isCartOrCheckout() && !isSubscribed() && !isInCooldown()) {
      window.addEventListener('scroll', updateScrollDepth, { passive: true });
      updateScrollDepth();
      window.setInterval(maybeAutoOpen, 1500);
      if (!isMobile()) {
        document.addEventListener('mouseout', onExitIntent);
      }
      /* Re-check when cookie banner disappears */
      if ('MutationObserver' in window) {
        var obs = new MutationObserver(function () {
          maybeAutoOpen();
        });
        obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        var cookieHost = document.querySelector('.jscookie_popup') || document.body;
        if (cookieHost) obs.observe(cookieHost, { attributes: true, childList: true, subtree: true });
      }
    }

    window.StudioLetters = {
      open: function (source) {
        openPrompt(source || 'navigation');
      },
      close: function () {
        closePrompt(true);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll(FORM_ROOT).forEach(function (root) {
      root.__slBound = false;
      bindForm(root);
    });
  });
})();
